import React from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const ParticlesBackground = () => {
  const particlesInit = async (main) => {
    await loadFull(main);
  };
  return (
    <div style={{ position: 'relative' }}>
      {/* Particles Component */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: {
            enable: true,
            zIndex: -1, // Ensure particles are in the background
          },
          particles: {
            number: {
              value: 150,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
value: [
  '#00ff99', // Neon Green
  '#00ccff', // Cyan Blue
  '#ff66cc', // Pink
  '#00ffcc', // Aqua
  '#ff9933', // Orange
  '#66ff66', // Light Green
  '#33ccff', // Sky Blue
  '#ff3399', // Hot Pink
  '#cc99ff', // Soft Purple
  '#ffff66', // Yellow
  '#0099ff', // Bright Blue
  '#66ffff', // Light Cyan
  '#ff6666', // Coral Red
  '#99ffcc', // Mint Green
  '#33ff99', // Fresh Green
  '#1b2650', // Deep Navy (your brand color)
  '#22bfca'  // Teal Blue (your brand accent)
],
            },
            shape: {
              type: 'char',
              character: {
value: [
  '{', '}', '(', ')', '[', ']', '<', '>', '/', '=', '+', '*', '#', '@', '!', '&', '%',
  'HTML', 'CSS', 'JavaScript', 'React Js', 'PHP', 'MySQL', 'SEO', 'Hosting', 'Domain', 'SSL',
  'CMS', 'WordPress', 'Email', 'Admin Panel', 'Dashboard', 'Maintenance', 'AMC', 
  'Real Estate', 'Educational', 'Ecommerce', 'Informative', 'Dynamic', 'Client', 
  'International', 'Responsive', 'Cross Browser Tested', 'UI/UX', 'Backend', 'Frontend',
  'Portfolio', 'Landing Page', 'Corporate', 'Agency', 'Business', 'Blog', 'News', 
  'Payment Gateway', 'Integration', 'Support', 'Analytics', 'Security', 'Performance', 
  'Optimization', 'Customization', 'Deployment'
],

                font: 'Courier New',
                weight: 'bold',
              },
            },
            opacity: {
              value: 0.6,
              random: true,
              anim: {
                enable: true,
                speed: 0.5,
                opacity_min: 0.2,
              },
            },
            size: {
              value: 10,
              random: true,
              anim: {
                enable: true,
                speed: 0.5,
                size_min: 4,
              },
            },
            move: {
              enable: true,
              speed: 0.03,
              out_mode: 'out',
            },
          },
          interactivity: {
            detect_on: 'canvas',
            events: {
              onHover: {
                enable: true,
                mode: 'repulse',
              },
              onClick: {
                enable: true,
                mode: 'push',
              },
            },
            modes: {
              repulse: {
                distance: 100,
                duration: 0.4,
              },
              push: {
                quantity: 4,
              },
            },
          },
        }}
        style={{ pointerEvents: 'none' }} // Prevent particles from blocking clicks
      />
    </div>
  );
};

export default ParticlesBackground;
